const modules: any = Object.create(null);
// 要排除加载的指令数组
const excludes: string[] = [];
const requireCtx = require.context('./', true, /(?<!(index))\.ts$/);

requireCtx.keys().forEach(key => {
    const modName = key.slice(2, -3);

    if (!excludes.includes(modName)) {
        const mod = requireCtx(key);
        modules[modName] = mod.__esModule && mod.default ? mod.default : mod;
    }
});

export function createFilter() {
    return function install(Vue: any) {
        return modules;
    };
}
